import TableCellBox from './TableCellBox';
export default TableCellBox;


// WEBPACK FOOTER //
// ./src/components/TableCellBox/index.js